import '../styles/progressIndicator.scss'

const ProgressIndicator = ({ chart, step }) => {
  return (
    <div className="progress-indicator">
      <div className={`${step === 0 ? 'active' : null}`}></div>
      <div className={`${step === 1 ? 'active' : null}`}></div>
      {chart !== 'wage' && (
        <div className={`${step === 2 ? 'active' : null}`}></div>
      )}
    </div>
  )
}

export default ProgressIndicator
